// @ts-nocheck
export const localeCodes =  [
  "de",
  "en",
  "nl",
  "fr",
  "it",
  "es",
  "bg",
  "bs",
  "cs",
  "da",
  "el",
  "et",
  "fi",
  "hr",
  "hu",
  "lt",
  "lv",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "tr"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_ae04d746",
      load: () => import("#nuxt-i18n/ae04d746" /* webpackChunkName: "locale_de_46json_ae04d746" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_1f3b6645",
      load: () => import("#nuxt-i18n/1f3b6645" /* webpackChunkName: "locale_en_46json_1f3b6645" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_17439438",
      load: () => import("#nuxt-i18n/17439438" /* webpackChunkName: "locale_nl_46json_17439438" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ca7f1331",
      load: () => import("#nuxt-i18n/ca7f1331" /* webpackChunkName: "locale_fr_46json_ca7f1331" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_99bd65f4",
      load: () => import("#nuxt-i18n/99bd65f4" /* webpackChunkName: "locale_it_46json_99bd65f4" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_193b1666",
      load: () => import("#nuxt-i18n/193b1666" /* webpackChunkName: "locale_es_46json_193b1666" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_9b3f1a29",
      load: () => import("#nuxt-i18n/9b3f1a29" /* webpackChunkName: "locale_bg_46json_9b3f1a29" */),
      cache: true
    }
  ],
  bs: [
    {
      key: "locale_bs_46json_44c82875",
      load: () => import("#nuxt-i18n/44c82875" /* webpackChunkName: "locale_bs_46json_44c82875" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_039bd2fe",
      load: () => import("#nuxt-i18n/039bd2fe" /* webpackChunkName: "locale_cs_46json_039bd2fe" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_ffd483a1",
      load: () => import("#nuxt-i18n/ffd483a1" /* webpackChunkName: "locale_da_46json_ffd483a1" */),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_2f869a1b",
      load: () => import("#nuxt-i18n/2f869a1b" /* webpackChunkName: "locale_el_46json_2f869a1b" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_46json_5b0d1cc2",
      load: () => import("#nuxt-i18n/5b0d1cc2" /* webpackChunkName: "locale_et_46json_5b0d1cc2" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_741f4d90",
      load: () => import("#nuxt-i18n/741f4d90" /* webpackChunkName: "locale_fi_46json_741f4d90" */),
      cache: true
    }
  ],
  hr: [
    {
      key: "locale_hr_46json_8bd82ed2",
      load: () => import("#nuxt-i18n/8bd82ed2" /* webpackChunkName: "locale_hr_46json_8bd82ed2" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_32ae0e36",
      load: () => import("#nuxt-i18n/32ae0e36" /* webpackChunkName: "locale_hu_46json_32ae0e36" */),
      cache: true
    }
  ],
  lt: [
    {
      key: "locale_lt_46json_9864c94e",
      load: () => import("#nuxt-i18n/9864c94e" /* webpackChunkName: "locale_lt_46json_9864c94e" */),
      cache: true
    }
  ],
  lv: [
    {
      key: "locale_lv_46json_959fb57f",
      load: () => import("#nuxt-i18n/959fb57f" /* webpackChunkName: "locale_lv_46json_959fb57f" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_ddccc624",
      load: () => import("#nuxt-i18n/ddccc624" /* webpackChunkName: "locale_no_46json_ddccc624" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_3918dbf0",
      load: () => import("#nuxt-i18n/3918dbf0" /* webpackChunkName: "locale_pl_46json_3918dbf0" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_871b17cc",
      load: () => import("#nuxt-i18n/871b17cc" /* webpackChunkName: "locale_pt_46json_871b17cc" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_f0600b7f",
      load: () => import("#nuxt-i18n/f0600b7f" /* webpackChunkName: "locale_ro_46json_f0600b7f" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_ac1d77d7",
      load: () => import("#nuxt-i18n/ac1d77d7" /* webpackChunkName: "locale_ru_46json_ac1d77d7" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_4ca9364f",
      load: () => import("#nuxt-i18n/4ca9364f" /* webpackChunkName: "locale_sk_46json_4ca9364f" */),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_bc622591",
      load: () => import("#nuxt-i18n/bc622591" /* webpackChunkName: "locale_sl_46json_bc622591" */),
      cache: true
    }
  ],
  sr: [
    {
      key: "locale_sr_46json_738db16e",
      load: () => import("#nuxt-i18n/738db16e" /* webpackChunkName: "locale_sr_46json_738db16e" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_38f38621",
      load: () => import("#nuxt-i18n/38f38621" /* webpackChunkName: "locale_sv_46json_38f38621" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_933a76ba",
      load: () => import("#nuxt-i18n/933a76ba" /* webpackChunkName: "locale_tr_46json_933a76ba" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "fr",
    name: "français",
    language: undefined
  },
  {
    code: "it",
    name: "italiano",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "bg",
    name: "български",
    language: undefined
  },
  {
    code: "bs",
    name: "босански",
    language: undefined
  },
  {
    code: "cs",
    name: "čeština",
    language: undefined
  },
  {
    code: "da",
    name: "dansk",
    language: undefined
  },
  {
    code: "el",
    name: "Ελληνικά",
    language: undefined
  },
  {
    code: "et",
    name: "eesti",
    language: undefined
  },
  {
    code: "fi",
    name: "suomi",
    language: undefined
  },
  {
    code: "hr",
    name: "hrvatski",
    language: undefined
  },
  {
    code: "hu",
    name: "magyar",
    language: undefined
  },
  {
    code: "lt",
    name: "lietuvių",
    language: undefined
  },
  {
    code: "lv",
    name: "latviešu",
    language: undefined
  },
  {
    code: "no",
    name: "norsk bokmål",
    language: undefined
  },
  {
    code: "pl",
    name: "polski",
    language: undefined
  },
  {
    code: "pt",
    name: "português",
    language: undefined
  },
  {
    code: "ro",
    name: "română",
    language: undefined
  },
  {
    code: "ru",
    name: "русский",
    language: undefined
  },
  {
    code: "sk",
    name: "slovenčina",
    language: undefined
  },
  {
    code: "sl",
    name: "slovenščina",
    language: undefined
  },
  {
    code: "sr",
    name: "српски",
    language: undefined
  },
  {
    code: "sv",
    name: "svenska",
    language: undefined
  },
  {
    code: "tr",
    name: "Türkçe",
    language: undefined
  }
]
/** client **/

/** client-end **/